import type { SVGProps } from "react";
import * as React from "react";

const SvgIconAw3 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="#E25444"
      fillRule="evenodd"
      d="m59.328 18.066-10.6 20.213 10.6 20.212 4.341-2.43V20.496z"
      clipRule="evenodd"
    />
    <path
      fill="#7B1D13"
      fillRule="evenodd"
      d="M59.328 18.066 38.13 20.497 27.34 38.279 38.13 56.06l21.198 2.43z"
      clipRule="evenodd"
    />
    <path
      fill="#58150D"
      fillRule="evenodd"
      d="m16.55 18.066-3.448 1.536v37.354l3.447 1.535L38.13 38.279z"
      clipRule="evenodd"
    />
    <path
      fill="#E25444"
      fillRule="evenodd"
      d="M16.503 18.023 38.16 24.05v28.997l-21.656 5.458z"
      clipRule="evenodd"
    />
    <path
      fill="#58150D"
      fillRule="evenodd"
      d="m38.17 27.235-9.195-1.479 9.195-10.461 9.173 10.461z"
      clipRule="evenodd"
    />
    <path
      fill="#58150D"
      fillRule="evenodd"
      d="m47.343 25.756-9.184 1.501-9.184-1.5V15.294M38.17 49.18l-9.195 1.706 9.195 8.984 9.173-8.984z"
      clipRule="evenodd"
    />
    <path
      fill="#7B1D13"
      fillRule="evenodd"
      d="m38.13 7.448-9.194 4.861v13.433l9.223-2.602zM38.159 30.531l-9.184 1.001v13.412l9.184 1.052zM38.159 53.16l-9.184-2.306v13.184l9.184 4.815z"
      clipRule="evenodd"
    />
    <path
      fill="#E25444"
      fillRule="evenodd"
      d="m47.343 50.854-9.184 2.307v15.692l9.184-4.815zM38.159 30.531l9.184 1.001v13.412l-9.184 1.052zM38.13 7.448l9.194 4.861v13.433l-9.194-2.559z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconAw3;
